import React from "react";
import { Box } from "@mui/material";

/**
 * Skip-to-content link for keyboard navigation accessibility.
 * Allows users to skip navigation and jump directly to main content.
 */
export const SkipToContent: React.FC = () => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const mainContent = document.querySelector("main");
    if (mainContent) {
      mainContent.focus();
      mainContent.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <Box
      component="a"
      href="#main-content"
      onClick={handleClick}
      sx={{
        position: "absolute",
        top: "-100px",
        left: 0,
        zIndex: 10000,
        padding: "8px 16px",
        backgroundColor: "primary.main",
        color: "white",
        textDecoration: "none",
        borderRadius: "4px",
        fontSize: "0.875rem",
        fontWeight: 500,
        "&:focus": {
          top: "10px",
          left: "10px",
        },
      }}
      aria-label="Skip to main content"
    >
      Skip to main content
    </Box>
  );
};
